import { makeActionCreator } from '../../../utilities'
import { AlertConstants } from './alert.constants'

export const showAlert = makeActionCreator(AlertConstants.SHOW_ALERT, 'alert')
export const resetAlert = makeActionCreator(AlertConstants.RESET_SHOW_ALERT)
